export default "__VITE_ASSET__BJX962zf__"